export default __webpack_public_path__ + "images/ZC.27b6cba.png";